import React from "react";
import { ColumnType } from "antd/lib/table";
import { EMPTY } from "constants/common";
import { AICC_CONVERSATION_TYPE } from "constants/aicc";
import { AiccConversation } from "types/model/aiccCustomer";
import ConversationHistory from "../ConversationHistory";
import { conversationIdColumn } from "../ConversationHistory/columnConfig";

interface Props {
  subUserId: string;
  languageId: number;
}

const leadingColumns: ColumnType<AiccConversation>[] = [
  {
    title: "Conversation Title",
    dataIndex: "title",
    key: "title",
    width: 240,
    ellipsis: true,
    render: (_, { title }) => title || EMPTY,
  },
  conversationIdColumn,
];

function ScenarioConversation({ subUserId, languageId }: Props) {
  return (
    <ConversationHistory
      subUserId={subUserId}
      languageId={languageId}
      title="Scenario Conversation History"
      conversationType={AICC_CONVERSATION_TYPE.scenario}
      leadingColumns={leadingColumns}
    />
  );
}

export default ScenarioConversation;
